var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { namespace } from 'vuex-class';
var CollectionExecutionModule = namespace("collection-execution");
import { MENU_CHANNEL } from "~/config/enum.config";
var AddContact = /** @class */ (function (_super) {
    __extends(AddContact, _super);
    function AddContact() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledDataSource = ["IMPORT", "INTERFACE"];
        _this.model = {};
        _this.rules = {};
        return _this;
    }
    AddContact.prototype.emitClose = function () {
        var form = this.$refs['form'];
        form.resetFields();
    };
    AddContact.prototype.created = function () {
        this.model = {
            caseId: "",
            custType: "",
            contName: "",
            sex: "",
            relation: "",
            idNumber: "",
            phone: "",
            idCardAddress: "",
            contAddress: "",
            homePhone: "",
            companyName: "",
            companyPhone: "",
            companyAddress: "",
        };
        this.rules = {
            custType: { required: true, message: "请选择角色" },
            contName: { required: true, message: "请输入联系人姓名" },
            sex: { required: true, message: "请选择性别" },
            // idNumber: { required: true, message: "请输入身份证号" },
            phone: { required: true, message: "请输入联系人号码" },
            relation: { required: true, message: "请选择客户关系" }
        };
    };
    AddContact.prototype.submit = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (v) {
            if (!v)
                return;
            if (_this.menuChannel === MENU_CHANNEL.Assist_tel ||
                _this.menuChannel === MENU_CHANNEL.Assist_visit ||
                _this.menuChannel === MENU_CHANNEL.Assist_legal) {
                _this.model.assistId = _this.otherData.assistId;
            }
            _this.model.caseId = _this.caseId;
            _this.caseOperatorPageService
                .addPersonalContact(_this.model)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                form.resetFields();
                _this.emitClose();
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService),
        Dependencies(CaseOperatorPageService)
    ], AddContact.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddContact.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddContact.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddContact.prototype, "otherData", void 0);
    __decorate([
        Emit("close")
    ], AddContact.prototype, "emitClose", null);
    AddContact = __decorate([
        Component({
            components: {}
        })
    ], AddContact);
    return AddContact;
}(Vue));
export default AddContact;
